import React, { useState } from "react";
import "./Admission.css";

export default function Admission() {
  const [activeStep, setActiveStep] = useState(0);
  const [activeForm, setActiveForm] = useState("saroornagar");
  const [formData, setFormData] = useState({
    studentName: "",
    parentName: "",
    mobile: "",
    email: "",
    classApplying: "",
    dob: "",
    message: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAdmissionSubmit = (e) => {
    e.preventDefault();
    const { studentName, parentName, mobile, email, classApplying, dob, message } = formData;
    const whatsappNumber = activeForm === "karmanghat" ? "9553763144" : "9553741544";
    
    // Construct beautifully formatted message text (completely without emoji icons to prevent diamond symbols)
    const formattedText = `*New Admission Enquiry*\n\n` +
      `*Student Name:* ${studentName}\n` +
      `*Parent Name:* ${parentName}\n` +
      `*Date of Birth:* ${dob || "N/A"}\n` +
      `*Mobile Number:* ${mobile}\n` +
      `*Email:* ${email}\n` +
      `*Branch:* ${activeForm === "karmanghat" ? "Karmanghat" : "Saroornagar"}\n` +
      `*Class Applying For:* ${classApplying || "N/A"}\n` +
      `*Message/Query:* ${message || "N/A"}`;
      
    const encodedText = encodeURIComponent(formattedText);
    const whatsappUrl = `https://wa.me/91${whatsappNumber}?text=${encodedText}`;
    
    window.open(whatsappUrl, "_blank");
    
    // Reset form
    setFormData({
      studentName: "",
      parentName: "",
      mobile: "",
      email: "",
      classApplying: "",
      dob: "",
      message: ""
    });
  };

  const steps = [
    {
      title: "Apply Online / Direct",
      content: [
        "Fill all the fields correctly and accurately.",
        "Ensure correct date of birth of the candidate.",
        "Provide full name with surname.",
        "Check spellings carefully.",
        "No changes will be accepted later."
      ]
    },
    {
      title: "Registration Process",
      content: [
        "Obtain prospectus & form.",
        "Interview/test date will be informed.",
        "Admission depends on seat availability.",
        "Fill and sign admission form.",
        "Pay fee along with form."
      ]
    },
    {
      title: "Nursery to Grade II",
      content: [
        "Admission through interview & observation.",
        "Both parents must attend.",
        "Same-day process."
      ]
    },
    {
      title: "Grade III to X",
      content: [
        "Written Aptitude Test required.",
        "Interview with Principal.",
        "Admission not guaranteed."
      ]
    },
    {
      title: "Documents",
      content: [
        "Admission form",
        "family Photograph",
        "DOB certificate",
        "Report card",
        "Transfer Certificate",
        "Caste certificate (if any)"
      ]
    }
  ];

  return (
    <div className="admission-container">

      <h1>Admission Process</h1>
      <p className="subtitle">
        Follow the steps below to understand our structured admission process.
      </p>

      {/* ===== STEPS ===== */}
      <div className="steps">
        {steps.map((step, index) => (
          <div
            key={index}
            className="step-wrapper"
            onClick={() => setActiveStep(index)}
          >
            <div className="step-top">
              <div className={`circle ${activeStep === index ? "active" : ""}`}>
                {index + 1}
              </div>
              {index !== steps.length - 1 && <div className="line"></div>}
            </div>
            <p className="step-label">{step.title}</p>
          </div>
        ))}
      </div>

      {/* ===== CONTENT ===== */}
      <div className="step-content">
        <h2>{steps[activeStep].title}</h2>
        <ul>
          {steps[activeStep].content.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
      </div>

      {/* ===== ELIGIBILITY ===== */}
      <div className="eligibility-section">
        <h2>Eligibility Criteria</h2>
        <p className="eligibility-sub">
          Please ensure the following requirements are met before applying.
        </p>

        <div className="eligibility-grid">

          <div className="eligibility-card">
            <h3>Age Criteria</h3>
            <ul>
              <li>Nursery: 3+ years</li>
              <li>PP1: 4+ years</li>
              <li>PP2: 5+ years</li>
              <li>Grade 1: 6+ years</li>
            </ul>
          </div>

          <div className="eligibility-card">
            <h3>Academic Requirement</h3>
            <ul>
              <li>Previous class completion required</li>
              <li>Report card submission mandatory</li>
              <li>Basic subject understanding expected</li>
            </ul>
          </div>

          <div className="eligibility-card">
            <h3>General Guidelines</h3>
            <ul>
              <li>Seats are limited</li>
              <li>Admission based on performance</li>
              <li>School decision is final</li>
            </ul>
          </div>

        </div>
      </div>

      {/* ===== FORM SECTION ===== */}
      <div className="form-section">

        <h2>Admission Enquiry</h2>
        <p className="form-sub">
          Choose your preferred branch and submit your enquiry.
        </p>

        {/* TOGGLE */}
        <div className="form-tabs">
          <button
            className={activeForm === "saroornagar" ? "active" : ""}
            onClick={() => setActiveForm("saroornagar")}
          >
            Saroornagar Branch
          </button>

          <button
            className={activeForm === "karmanghat" ? "active" : ""}
            onClick={() => setActiveForm("karmanghat")}
          >
            Karmanghat Branch
          </button>
        </div>

        {/* FORM */}
        <form className="admission-form" onSubmit={handleAdmissionSubmit}>

          <h3 className="branch-title">
            {activeForm === "saroornagar"
              ? "Saroornagar Branch Enquiry"
              : "Karmanghat Branch Enquiry"}
          </h3>

          <div className="form-row">
            <input 
              type="text" 
              name="studentName"
              placeholder="Student Name" 
              value={formData.studentName}
              onChange={handleInputChange}
              required 
            />
            <input 
              type="text" 
              name="parentName"
              placeholder="Parent Name" 
              value={formData.parentName}
              onChange={handleInputChange}
              required 
            />
          </div>

          <div className="form-row">
            <input 
              type="tel" 
              name="mobile"
              placeholder="Mobile Number" 
              value={formData.mobile}
              onChange={handleInputChange}
              required 
            />
            <input 
              type="email" 
              name="email"
              placeholder="Email Address" 
              value={formData.email}
              onChange={handleInputChange}
              required 
            />
          </div>

          <div className="form-row">
            <input 
              type="text" 
              name="classApplying"
              placeholder="Class Applying For" 
              value={formData.classApplying}
              onChange={handleInputChange}
            />
            <input 
              type="date" 
              name="dob"
              title="Student Date of Birth"
              value={formData.dob}
              onChange={handleInputChange}
            />
          </div>

          <textarea 
            name="message"
            placeholder="Message / Query"
            value={formData.message}
            onChange={handleInputChange}
          ></textarea>

          {/* hidden branch value */}
          <input type="hidden" value={activeForm} />

          <button type="submit">Submit Enquiry</button>

        </form>

      </div>

    </div>
  );
}